import { render, staticRenderFns } from "./ViewAcknowledgeProblem.vue?vue&type=template&id=e0840a8e&"
import script from "./ViewAcknowledgeProblem.vue?vue&type=script&lang=js&"
export * from "./ViewAcknowledgeProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports